import React, { useState, useEffect } from "react";
// import { X } from "lucide-react";
// import ClearInput from "../../../CommonComponents/ClearInput";
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import {
    FillButton,
    GrayButton,
} from "../../../assets/components/ButtonGroup";
import PlaceholderB from "../../../assets/components/PlaceholderB";
import arrowleft from "../../../assets/icons/Arrow/left.svg";
import { Chip } from "../../../assets/components/Chip";
import {
    fetchSiksinMenus,
    fetchSiksinMenusByBusinessNumber,
} from "../../../utils/siksinMenus";
import { getEffectiveRepresentativeMenus } from "../../../utils/representativeMenus";

const Step1 = ({ data, userMenu, updateData, onNext, onHome }) => {
    const [, setAttempted] = useState(false);
    // const isValid = !!data.category || !!data.customMenu?.trim();
    const customMenu = (data?.customMenu ?? "").trim();
    const isValid = customMenu.length > 0 && customMenu !== "null";
    const [hasInitialized, setHasInitialized] = useState(false);
    const [recommendedMenus, setRecommendedMenus] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState(null);

    const localStoreId =
        localStorage.getItem("local_store_id")
            ? Number(localStorage.getItem("local_store_id"))
            : null;
    const storeBusinessNumber = localStorage.getItem("store_business_number") || "";

    useEffect(() => {
        if (!hasInitialized && !data.customMenu && userMenu) {
            updateData({ customMenu: userMenu });
            setHasInitialized(true);
        }
    }, [hasInitialized, data.customMenu, userMenu, updateData]);

    useEffect(() => {
        let alive = true;

        (async () => {
            const registerTag = localStorage.getItem("registerTag") || "";
            const menus = localStoreId
                ? await fetchSiksinMenus(localStoreId)
                : await fetchSiksinMenusByBusinessNumber(storeBusinessNumber);
            if (!alive) return;

            const effective = getEffectiveRepresentativeMenus({
                storeBusinessNumber,
                dbMenus: Array.isArray(menus) ? menus : [],
                registerTag,
            });

            const nextRecommended = Array.isArray(effective) ? effective : [];
            setRecommendedMenus(nextRecommended);
            const matched = nextRecommended.find((m) => m === displayValue) || null;
            setSelectedMenu(matched);
        })();

        return () => {
            alive = false;
        };
    }, [localStoreId, storeBusinessNumber]);

    const handleCustomInput = (e) => {
        const nextValue = e.target.value;
        updateData({
            customMenu: nextValue,
            category: "", // 버튼 선택값 초기화
        });
        setSelectedMenu(nextValue === selectedMenu ? selectedMenu : null);
    };

    const applyMenu = (menu) => {
        const nextValue = String(menu || "");
        setSelectedMenu(nextValue);
        updateData({
            customMenu: nextValue,
            category: "",
        });
    };

    const handleNext = () => {
        setAttempted(true);
        if (!isValid) return;

        const refined = {
            ...data,
            category: data.category || "",
            customMenu: data.customMenu || "",
        };

        // 둘 중 하나만 값 유지
        if (refined.category) refined.customMenu = "";
        if (refined.customMenu) refined.category = "";

        updateData(refined);
        onNext();
    };

    const displayValue = ["null", null, undefined].includes(data?.customMenu)
        ? ""
        : data.customMenu;

    return (
        <div className="min-h-screen">
            <HeaderIconL
                title="AI 이미지 생성"
                icon={arrowleft}
                onIconClick={onHome}
            />

            <div className="flex flex-col py-[24px] px-[16px] gap-[6px]">
                <h2 className="text-t2">
                    어떤 상품을 이미지로 생성할까요?
                </h2>
                <p className="text-b1 text-text-subtler pt-2 pb-8">
                    마케팅 이미지에 넣고 싶은 상품을 작성해 주세요.
                </p>

                {/* {attempted && !isValid && (
                    <p className="text-lg text-red-500 pt-2">
                        업종을 입력해주세요.
                    </p>
                )} */}

                <div className="pt-6">
                    <PlaceholderB
                        label="상품명"
                        placeholder="예) 삼겹살/아메리카노/송편"
                        maxLength={20}
                        showCounter
                        value={displayValue}
                        rightIconMode="clear"
                        onChange={handleCustomInput}
                    />
                </div>

                {recommendedMenus.length > 0 && (
                    <div className="mt-4 flex flex-wrap gap-2">
                        {recommendedMenus.map((m) => (
                            <Chip
                                key={m}
                                chip="d"
                                status={m === selectedMenu ? "selected" : "default"}
                                className={
                                    m === selectedMenu
                                        ? "bg-surface-light-white border-black text-black"
                                        : ""
                                }
                                label={m}
                                onClick={() => applyMenu(m)}
                            />
                        ))}
                    </div>
                )}

                <div className="fixed bottom-0 left-0 right-0">
                    {isValid ? (
                        <FillButton className="w-full" onClick={handleNext}>
                            다음
                        </FillButton>
                    ) : (
                        <GrayButton className="w-full" disabled>
                            다음
                        </GrayButton>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Step1;
